import {
  UPDATE_TIMER,
} from './types';

/**
 *
 * @param payload
 * @returns {Function}
 */
const updateTimer = (payload) => dispatch => {
  dispatch({ type: UPDATE_TIMER, payload });
};

export default {
  updateTimer,
};



// WEBPACK FOOTER //
// ./src/actions/timer.js